// Environment configuration
const isDevelopment = import.meta.env.DEV || window.location.hostname === 'localhost'
const API_BASE = isDevelopment ? 'http://localhost:3000/api' : 'https://api.share.is.einhell-connect.com/api'

export const config = {
  // Azure Functions API endpoints
  api: {
    // Admin Authentication (magic link based)
    sendAdminAuth: `${API_BASE}/SendAdminAuth`,
    validateAdminAuth: `${API_BASE}/ValidateAdminAuth`,
    
    // Admin Functions (require magic link auth)
    createInvitation: `${API_BASE}/CreateInvitation`,
    getInvitations: `${API_BASE}/GetInvitations`,
    updateInvitationName: `${API_BASE}/UpdateInvitationName`,
    shareInvitation: `${API_BASE}/ShareInvitation`,
    getSharedInvitations: `${API_BASE}/GetSharedInvitations`,
    
    // User Functions (token-based)
    validateToken: `${API_BASE}/ValidateToken`,
    generateUploadUrl: `${API_BASE}/GenerateUploadUrl`,
    generateDownloadUrl: `${API_BASE}/GenerateDownloadUrl`,
    getDownloadableFiles: `${API_BASE}/GetDownloadableFiles`,
    completeUpload: `${API_BASE}/CompleteUpload`,
    getUploadFiles: `${API_BASE}/GetUploadFiles`,
    createDownloadInvitation: `${API_BASE}/CreateDownloadInvitation`,
    
    // Email verification functions
    requestEmailCode: `${API_BASE}/RequestEmailCode`,
    verifyEmailCode: `${API_BASE}/VerifyEmailCode`,
    
    // Direct Upload Functions (no auth required)
    requestDirectUpload: `${API_BASE}/RequestDirectUpload`,
    
    // Admin Management Functions (require admin auth)
    getFreeInvitations: `${API_BASE}/GetFreeInvitations`,
    addAllowedUploader: `${API_BASE}/AddAllowedUploader`,
    getAllowedUploaders: `${API_BASE}/GetAllowedUploaders`,
  },
  
  // Application settings
  app: {
    name: 'File Share App',
    maxFileSize: 2 * 1024 * 1024 * 1024, // 2GB
    allowedFileTypes: [
      '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx',
      '.txt', '.csv', '.zip', '.rar', '.7z',
      '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.heic',
      '.mp4', '.avi', '.mov', '.wmv', '.flv',
      '.mp3', '.wav', '.flac', '.aac',
      '.bin', '.tar', '.gz', '.bz2', '.xz', '.tgz',
      '.log', '.md', '.json', '.diff', '.apk'
    ],
  },
}

// API configuration is now determined by environment detection
console.log(`🔧 API Configuration: ${isDevelopment ? 'Development (localhost + proxy)' : 'Production (direct API calls)'}`)
